 <template>
     <div>
        <edit-content-modal
            v-model="show_content1_dialog"
            :modelProp="contents.contracts_iatse667_agreements_1"
            :constants="constants"
            refElement="contracts_iatse667_agreements_1"
            @updatedContent="updateContent"
        />
        <edit-content-modal
            v-model="show_content2_dialog"
            :modelProp="contents.contracts_iatse_agreements_1"
            :constants="constants"
            refElement="contracts_iatse_agreements_1"
            @updatedContent="updateContent"
        />

        <v-form name="editForm" ref="editForm">

            <h4 class="tw-text-secondary mt-3 mb-3">Contracts</h4>

            <div class="tw-flex tw-flex-col tw-gap-4 tw-p-1">
                <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
                    <div class="tw-flex-grow">

                        <h5 class="mt-3 mb-3">IATSE667 Agreements</h5>

                        <v-file-input
                            v-model="modelObject.collective_agreement"
                            label="Collective Agreement"
                            accept="application/pdf"
                            dense
                            outlined
                            hide-details
                            class="mb-3"
                        >
                        </v-file-input>

                        <v-file-input
                            v-model="modelObject.summary_rate_fringes_ia667"
                            label="Summary of Rate and Fringes IA667"
                            accept="application/pdf"
                            dense
                            outlined
                            hide-details
                            class="mb-3"
                        >
                        </v-file-input>

                        <v-file-input
                            v-model="modelObject.summary_rate_fringes_ia671"
                            label="Summary of Rate and Fringes IA671"
                            accept="application/pdf"
                            dense
                            outlined
                            hide-details
                            class="mb-3"
                        >
                        </v-file-input>

                    </div>
                    <div class="tw-flex-grow">

                        <h5 class="mt-3 mb-3">IATSE Agreements</h5>

                        <v-file-input
                            v-model="modelObject.low_budget"
                            label="Low budget Theatrical Agreement"
                            accept="application/pdf"
                            dense
                            outlined
                            hide-details
                            class="mb-3"
                        >
                        </v-file-input>

                        <v-file-input
                            v-model="modelObject.low_budget_canadian_667"
                            label="L.B.T.A. Canadian Supplement 667 Specific"
                            accept="application/pdf"
                            dense
                            outlined
                            hide-details
                            class="mb-3"
                        >
                        </v-file-input>
                    </div>
                </div>
            </div>

            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
                <div class="tw-w-1/2 pl-9">
                    <p class="description" ref="contracts_iatse667_agreements_1" v-html="$root.sanitizeAndTruncateHTML(contents.contracts_iatse667_agreements_1.body, 1000)"></p>
                    <v-btn :loading="saveLoading" class="mr-2 main-btn" @click="editContentModal('show_content1_dialog')">Edit Description</v-btn>
                </div>
                <div class="tw-w-1/2 pl-9 ml-9">
                    <p class="description" ref="contracts_iatse_agreements_1" v-html="$root.sanitizeAndTruncateHTML(contents.contracts_iatse_agreements_1.body, 1000)"></p>
                    <v-btn :loading="saveLoading" class="mr-2 main-btn" @click="editContentModal('show_content2_dialog')">Edit Description</v-btn>
                </div>
            </div>

            <v-divider class="my-4"></v-divider>

            <div class="tw-flex tw-justify-end">
                <v-btn :loading="saveLoading" :disabled="isEmptyUpload" class="main-btn" @click="uploadFiles">Upload</v-btn>
            </div>

        </v-form>
    </div>

</template>

<script>
import EditContentModal from "@/Modals/EditContentModal.vue";

export default {
    name: "WebsiteContentContracts",
    components: {
        EditContentModal
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'contents': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            show_content1_dialog: false,
            show_content2_dialog: false,
            modelObject: {},
            saveLoading: false,
        }
    },
    mounted() {
        //
    },
    computed: {
        isEmptyUpload() {
            //return Object.keys(this.modelObject).length === 0
            return !Object.values(this.modelObject).some(value => value !== null);
        }
    },
    methods: {
        emptyUpload() {
            for (let key in this.modelObject) {
                this.modelObject[key] = null
            }
        },
        editContentModal(editor) {
            this[editor] = true
        },
        updateContent(content, ref) {
            if (!ref) {
                return;
            }
            if (!this.$refs[ref]) {
                return;
            }
            this.$refs[ref].innerHTML = content;
        },
        uploadFiles() {
            if (this.$refs.editForm.validate())
            {
                this.saveLoading = true

                let formData = new FormData()
                formData.append("_method", "put")

                for (let key in this.modelObject) {
                    let value = this.modelObject[key];
                    if (value instanceof File) {
                        formData.append(key, value);
                    }
                }

                var url = route('iatsecontracts.upload')
                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Files have been saved')
                            this.saveLoading = false
                            this.emptyUpload()
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                        this.saveLoading = false
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        }
    }
}
</script>
 <style scoped>
 .description {
     font-size: 0.9em;
 }
 </style>
